function appendTextElement (documentRef, parent, tagName, text, classNames = []) {
  const element = documentRef.createElement(tagName)
  element.classList.add(...classNames)
  element.textContent = String(text || '')
  parent.appendChild(element)
  return element
}

function safeHttpUrl (value, baseUrl) {
  try {
    const url = new URL(String(value || ''), baseUrl)
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) return null
    return url.toString()
  } catch (error) {
    return null
  }
}

function safeTelephoneHref (phone) {
  const value = String(phone || '').trim()
  return /^\+?[0-9 ()/.-]{3,32}$/.test(value) ? `tel:${value}` : null
}

function safeDetailUrl (baseUrl, slug) {
  const safeBase = safeHttpUrl(baseUrl, 'https://www.armstark.de/')
  const value = String(slug || '').trim()
  if (!safeBase || !/^[\p{L}\p{N}_-]+$/u.test(value)) return null
  return new URL(`${encodeURIComponent(value)}/`, safeBase.endsWith('/') ? safeBase : `${safeBase}/`).toString()
}

function appendAction (documentRef, parent, label, href, className) {
  if (!href) return
  const action = documentRef.createElement('div')
  action.classList.add('content__action', className)
  const link = documentRef.createElement('a')
  link.classList.add('btn', '-btn-small', className === 'content__action--phone' ? '-btn-alpha' : '-btn-grey-inverted')
  link.setAttribute('href', href)
  appendTextElement(documentRef, link, 'span', label)
  action.appendChild(link)
  parent.appendChild(action)
}

export function createDealerPopup ({
  dealer,
  detailListingBase,
  documentRef = document,
  fallbackImageUrl,
  labels,
  mobile
}) {
  const module = documentRef.createElement('div')
  module.classList.add('module-map-popup')
  if (mobile) module.classList.add('-mobile')

  const wrapper = documentRef.createElement('div')
  wrapper.classList.add('map-popup-wrapper')
  const imageWrapper = documentRef.createElement('div')
  imageWrapper.classList.add('map-popup__image')
  const image = documentRef.createElement('img')
  const requestedImage = dealer.imageLocation ? String(dealer.imageLocation).split('|')[0] : ''
  const imageUrl = safeHttpUrl(requestedImage, detailListingBase) || safeHttpUrl(fallbackImageUrl, detailListingBase)
  if (imageUrl) image.setAttribute('src', imageUrl)
  image.setAttribute('alt', `${String(dealer.name || '')} Logo`)
  imageWrapper.appendChild(image)
  wrapper.appendChild(imageWrapper)

  const content = documentRef.createElement('div')
  content.classList.add('map-popup__content')
  const name = documentRef.createElement('div')
  name.classList.add('content__name')
  appendTextElement(documentRef, name, 'span', String(dealer.name || '').replace('ARMSTARK® ', ''))
  content.appendChild(name)

  appendAction(documentRef, content, labels.phone, safeTelephoneHref(dealer.phone), 'content__action--phone')

  const directions = new URL('https://maps.google.de/')
  directions.searchParams.set('saddr', '')
  directions.searchParams.set('daddr', `${String(dealer.street || '')}, ${String(dealer.zip || '')} ${String(dealer.city || '')}, ${String(dealer.name || '')}`)
  appendAction(documentRef, content, labels.route, directions.toString(), 'content__action--route')
  const routeLink = content.children[content.children.length - 1]?.children[0]
  if (routeLink) {
    routeLink.setAttribute('target', '_blank')
    routeLink.setAttribute('rel', 'noopener noreferrer')
  }

  const detailUrl = safeDetailUrl(detailListingBase, dealer.slug)
  if (detailUrl) {
    const detail = documentRef.createElement('div')
    detail.classList.add('content__link')
    const link = documentRef.createElement('a')
    link.setAttribute('href', detailUrl)
    appendTextElement(documentRef, link, 'span', labels.detail)
    detail.appendChild(link)
    content.appendChild(detail)
  }

  wrapper.appendChild(content)
  module.appendChild(wrapper)
  return module
}
